import { render, staticRenderFns } from "./TableSpinner.vue?vue&type=template&id=41186fda&"
import script from "./TableSpinner.vue?vue&type=script&lang=js&"
export * from "./TableSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports